import { FC, PropsWithChildren } from 'react';

import { useAuthenticated } from '../../hooks/useAuthenticated';
import { FlowSpinner } from '../FlowSpinner/FlowSpinner';

export const AuthenticationGuard: FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthenticated();

  if (isLoading) {
    return <FlowSpinner />;
  } else if (isAuthenticated) {
    return children;
  }
  return null;
};
